import handleToggleAddonModal from 'sites/pivothealth.com/fixed-benefit-medical/consumer/quotes/registryListenersDOM/handleToggleAddonModal'
import handleOpenModalDental from 'sites/pivothealth.com/short-term-health-insurance/consumer/start-application/registryListenersDOM/handleOpenModalDental'
import handleOpenModalLatitude from 'sites/pivothealth.com/short-term-health-insurance/consumer/start-application/registryListenersDOM/handleOpenModalLatitude'
import clickEventName from 'utils/DOM/clickEventName'
import handleToggleAddon from './handleToggleAddon'
import handleToggleVision from './handleToggleVision'

function registryListenersDOMISC() {
  $('body')
    .on('change', '.js-vision-input', handleToggleVision)
    .on('change', '.addon__input', handleToggleAddon)
    .on(clickEventName, '.js-add-on-btn', handleToggleAddonModal)
    .on(clickEventName, '.js-latitude-btn', handleToggleAddonModal)
    .on(
      clickEventName,
      '.addOn-modal__info a.addOn__link, .dental-brochure',
      function (e) {
        const planId = e.target.getAttribute('data-ids')
        window.dataLayerPushEvent(`VIEW_BROCHURE_DETAILS_DENTAL_VISION-${planId}`)
      }
    )
    .on(clickEventName, '.latitude-brochure', function (e) {
      const planId = e.target.getAttribute('data-ids')
      window.dataLayerPushEvent(`VIEW_BROCHURE_DETAILS_LATITUDE-${planId}`)
    })
    .on(clickEventName, '.js-modal', handleOpenModalDental)
    .on(clickEventName, '.js-modal-latitude', handleOpenModalLatitude)
}

export default registryListenersDOMISC
